import { useOrg } from 'src/modules/propertyDetails/hooks/useHasAccessForOrg';
import { logErrorWithTags } from 'src/shared/telemetry/logger';

export const usePropertyDetailsError = () => {
  const { org } = useOrg();

  const logError = (error: Error) => {
    logErrorWithTags(error, { featureName: 'propertyDetails', orgId: org?.id });
  };

  return { logError };
};
